import PageHero from '../components/PageHero';

const SHOP = 'https://lddy.no/1gdr8';

const products = [
  {
    name: 'Nourish',
    image: '/images/nourish.png',
    for: 'All hair types',
    description:
      'Nourish is Eufora’s everyday moisture line for all hair types and textures. A blend of proteins, nutrients, oils, and plant extracts adds lightweight hydration, softness, and shine, and leaves hair easier to manage.',
  },
  {
    name: "Smooth'n",
    image: '/images/smoothn.png',
    for: 'Frizz control',
    description:
      "Smooth'n is Eufora's anti-frizz line. Its Smooth'n Oil Complex builds up over repeated use to control frizz, add moisture and shine, and make styling faster each time.",
  },
  {
    name: "Curl'n",
    image: '/images/curln.png',
    for: 'Curls & waves',
    description:
      "Curl'n is Eufora's line for curls and waves. Aloe-based formulas with amino acids, curl-enhancing enzymes, and Abyssinian and Moringa oils define curls, lock in moisture, and fight frizz.",
  },
  {
    name: 'Thickening',
    image: '/images/thickening.png',
    for: 'Fine & thinning hair',
    description:
      'Thickening is Eufora’s line for fine and thinning hair. Built on the exclusive ProAmino Cell Complex, it nourishes the scalp, supports the follicle, and helps guard against the follicle atrophy linked to hair loss.',
  },
  {
    name: 'Volume',
    image: '/images/volume.png',
    for: 'Lift & body',
    description:
      'Volume is Eufora’s line for fine or limp hair. It adds lightweight body, lift, and bounce that holds a style through the day.',
  },
];

const Products = () => (
  <div className="page">
    <PageHero kicker="Products" title="Eufora, the line we trust on every head.">
      Plant-based, salon-only care made to protect color and keep your style
      looking the way it did the moment you left the chair. Ask your stylist
      which regimen fits your hair.
    </PageHero>

    <section className="section--tight">
      <div className="container prod-feature">
        <div className="prod-feature__media reveal">
          <div className="arch">
            <img
              src="/images/eufora-wall.jpg"
              alt="The Loft's full Eufora retail wall, stocked on reclaimed-wood and pipe shelving"
              loading="lazy"
            />
          </div>
        </div>
        <div className="prod-feature__copy reveal" data-reveal="100">
          <span className="kicker">On the shelf</span>
          <h2>The whole line lives on our wall.</h2>
          <p className="lede">
            Every regimen below is stocked in the salon, on the brick wall up
            front. Your stylist will match you to the right one, and you can take
            it home the same day you sit in the chair.
          </p>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="prod-list">
          {products.map((product, i) => (
            <article className="prod-row reveal" key={product.name}>
              <div className="prod-row__media">
                <div className="prod-row__panel grain">
                  <img src={product.image} alt={`Eufora ${product.name}`} loading="lazy" />
                </div>
              </div>
              <div className="prod-row__body">
                <span className="prod-row__for">{product.for}</span>
                <h2>{product.name}</h2>
                <p>{product.description}</p>
                <a className="btn btn--ghost" href={SHOP} target="_blank" rel="noopener noreferrer">
                  {`Shop ${product.name} `}<span className="arrow">→</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="section--tight section--warm">
      <div className="container text-center">
        <div className="reveal" style={{ maxWidth: '640px', marginInline: 'auto' }}>
          <span className="kicker" style={{ justifyContent: 'center' }}>Take it home</span>
          <h2>Shop the full Eufora collection.</h2>
          <p className="lede" style={{ marginInline: 'auto', marginTop: 'var(--space-4)' }}>
            Browse every line and reorder your favorites through our Eufora
            storefront.
          </p>
          <a
            className="btn btn--primary"
            href={SHOP}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: 'var(--space-6)' }}
          >
            Visit the Eufora shop
          </a>
        </div>
      </div>
    </section>
  </div>
);

export default Products;
